<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y7wbhL/tc-custom/cover.jpg?1684514917057?1702530946698" alt="This image is the cover for the book A History of Mormon Landmarks in Utah, Landmarks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A History of Mormon Landmarks in Utah, Landmarks
      </h1>
      <p class="bookDescription body article font2">
        <p>The home state of The Church of Jesus Christ of Latter-day Saints is a land of rugged mountains, deep canyon lands and majestic rivers. Utah and Mormon history are entwined, as so many early followers of the faith settled the region beginning in 1847. They preserved their values and heritage in the numerous temples, forts, tabernacles and cemeteries that serve as historic sacred monuments for the modern church. Author and LDS member Andy Weeks explores the history behind the landmarks that exalt the rich, deeply rooted history of Mormonism in the Beehive State.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andy Weeks
      </h2>
      
      <p class="authorDescription body article">Andy Weeks is an award-winning journalist who has worked for newspapers and other media outlets in Utah and Idaho. His work, both fiction and non-fiction, has appeared in magazines in both the U.S. and the UK, and he is the author of several travel-related and history books, including Haunted Utah: Ghosts and Strange Phenomena of the Beehive State. He currently is at work on his next project.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6c44a51b